/* Da Luca mobile acceptance. No cart writes, no price/option serialization,
   no signup submission and no gesture interception in this presentation layer. */
(function () {
  'use strict';
  if (window.DaLucaLaunchMobile) return;
  window.DaLucaLaunchMobile = true;
  const main = document.getElementById('main-content');
  const root = document.documentElement;
  const offerRecords = new Map();
  const shadowRoots = new Set();
  const observedDrawers = new WeakSet();
  let frame = 0, teaserTimer = 0, preferredOffer = null, preferredSeen = false, sequence = 0;

function stationaryGalleryZoom() {
  document.querySelectorAll('.product-image-container > product-slider').forEach(slider => {
    if (slider.classList.contains('dl-stationary-zoom')) return;
    const source = slider.querySelector('.product-single__media-zoom');
    if (!source) return;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'dl-gallery-zoom';
    button.setAttribute('aria-label', source.getAttribute('aria-label'));
    const icon = source.querySelector('svg');
    if (icon) button.appendChild(icon.cloneNode(true));
    const selectedLink = () => {
      const selected = slider.querySelector('.product-images__slide.is-selected') ||
        slider.querySelector('.product-images__slide.is-initial-selected') ||
        slider.querySelector('.product-images__slide.is-active');
      return selected && selected.querySelector('.product-single__media-zoom');
    };
    const sync = () => { button.hidden = !selectedLink(); };
    button.addEventListener('click', event => {
      event.preventDefault();
      const link = selectedLink();
      if (link) link.click();
    });
    slider.insertAdjacentElement('afterend', button);
    slider.classList.add('dl-stationary-zoom');
    const observer = new MutationObserver(sync);
    observer.observe(slider, {subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden']});
    sync();
  });
}

  function captionClearance() {
    main?.querySelectorAll('.daluca-craft-journey__diagram > small').forEach(caption => {
      let parent = caption.parentElement;
      while (parent) {
        const background = getComputedStyle(parent).backgroundColor;
        if (background !== 'rgba(0, 0, 0, 0)' && background !== 'transparent') {
          if (caption.style.getPropertyValue('--dl-lug-caption-bg') !== background) caption.style.setProperty('--dl-lug-caption-bg',background);
          break;
        }
        parent = parent.parentElement;
      }
    });
  }

  function editingPlacement() {
    window.DaLucaCartEditor?.refreshUi?.();
  }

  function cartControls() {
    document.querySelectorAll('#Cart .product-cart-item, #Cart-Drawer .product-cart-item').forEach(item => {
      const copy = Array.from(item.children).find(node => node.tagName === 'DIV' &&
        !node.classList.contains('product-cart-item-image') && !node.classList.contains('dl-launch-cart-actions'));
      if (!copy) return;
      const edit = copy.querySelector(':scope > .daluca-cart-edit-link');
      const quantity = copy.querySelector(':scope > quantity-selector');
      const remove = copy.querySelector(':scope > cart-remove');
      if (!edit && !quantity && !remove) return;
      let actions = item.querySelector(':scope > .dl-launch-cart-actions');
      if (!actions) { actions = document.createElement('div'); actions.className = 'dl-launch-cart-actions'; item.appendChild(actions); }
      if (edit) actions.prepend(edit);
      let count = actions.querySelector(':scope > .dl-launch-count-controls');
      if (!count && (quantity || remove)) {
        count = document.createElement('div'); count.className = 'dl-launch-count-controls'; actions.appendChild(count);
      }
      // Reparent existing controls, never clone inputs, IDs, data-index or listeners.
      if (quantity) count.appendChild(quantity);
      if (remove) count.appendChild(remove);
    });
  }

  function mobileMenu() {
    const wrapper = document.querySelector('.dl-mobile-toggle-wrapper');
    const menu = document.getElementById('mobile-menu');
    const summary = wrapper?.querySelector(':scope > summary');
    if (!wrapper || !menu || !summary || menu.hasAttribute('data-dl-menu-controller')) return;
    menu.setAttribute('data-dl-menu-controller', '');
    const anchor = document.createComment('mobile navigation');
    wrapper.before(anchor);
    const media = matchMedia('(max-width:1067px)');
    const portal = document.createElement('div');
    portal.className = 'dl-launch-menu-portal';
    portal.setAttribute('role', 'dialog');
    portal.setAttribute('aria-modal', 'true');
    portal.setAttribute('aria-label', menu.getAttribute('aria-label') || summary.getAttribute('aria-label'));
    const openLabel = summary.getAttribute('aria-label');
    const closeLabel = window.DaLucaI18n.chainText(() => (document), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['#Cart-Drawer side-panel-close']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) ||
      window.DaLucaI18n.chainText(() => (document), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.side-panel-close']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || 'Close';
    const menuRole = menu.getAttribute('role');
    const scroll = document.createElement('div');
    scroll.className = 'dl-launch-menu-scroll';
    let active = false, savedScroll = null;
    const prepareGeometry = () => {
      const viewport = window.visualViewport;
      portal.style.setProperty('--dl-mobile-menu-top', Math.max(0, viewport?.offsetTop || 0) + 'px');
      portal.style.setProperty('--dl-mobile-menu-left', Math.max(0, viewport?.offsetLeft || 0) + 'px');
      portal.style.setProperty('--dl-mobile-menu-width', (viewport?.width || window.innerWidth) + 'px');
      portal.style.setProperty('--dl-mobile-menu-height', Math.max(1, viewport?.height || window.innerHeight) + 'px');
    };
    const geometry = () => { if (active) prepareGeometry(); };
    const restoreScroll = () => {
      if (!savedScroll) return;
      const behavior = root.style.getPropertyValue('scroll-behavior');
      const priority = root.style.getPropertyPriority('scroll-behavior');
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(savedScroll.x, savedScroll.y);
      if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
      else root.style.removeProperty('scroll-behavior');
      savedScroll = null;
    };
    const syncMenu = () => {
      const open = wrapper.hasAttribute('open') && media.matches;
      summary.setAttribute('aria-expanded', String(open));
      wrapper.setAttribute('aria-expanded', String(open));
      wrapper.classList.toggle('active', open);
      summary.setAttribute('aria-label', open ? closeLabel : openLabel);
      if (open) {
        if (!active) {
          savedScroll = {x:window.scrollX, y:window.scrollY};
          prepareGeometry();
          wrapper.classList.add('dl-launch-menu-wrapper');
          menu.setAttribute('role', 'navigation');
          while (menu.firstChild) scroll.appendChild(menu.firstChild);
          menu.appendChild(scroll);
          portal.appendChild(wrapper);
          root.style.setProperty('--dl-menu-page-top', -savedScroll.y + 'px');
          root.classList.add('dl-launch-menu-open');
          document.body.appendChild(portal);
          active = true;
        } else geometry();
        menu.removeAttribute('inert');
        if (!portal.contains(document.activeElement)) summary.focus({preventScroll:true});
      } else {
        if (!media.matches) wrapper.removeAttribute('open');
        if (active) {
          while (scroll.firstChild) menu.insertBefore(scroll.firstChild, scroll);
          scroll.remove();
          if (anchor.parentNode) anchor.after(wrapper);
          portal.remove();
          wrapper.classList.remove('dl-launch-menu-wrapper');
          if (menuRole === null) menu.removeAttribute('role');
          else menu.setAttribute('role', menuRole);
          root.classList.remove('dl-launch-menu-open');
          root.style.removeProperty('--dl-menu-page-top');
          active = false;
          restoreScroll();
        }
        if (!document.querySelector('#Cart-Drawer:not([inert]), .product-popup-modal[open]')) document.body.classList.remove('overflow-hidden');
      }
      queueOffers();
    };
    const closeMenu = () => {
      wrapper.removeAttribute('open');
      syncMenu();
      summary.focus({preventScroll:true});
    };
    summary.addEventListener('click', event => {
      if (!media.matches) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      wrapper.toggleAttribute('open', !wrapper.hasAttribute('open'));
      syncMenu();
      if (!wrapper.hasAttribute('open')) summary.focus({preventScroll:true});
    }, true);
    portal.addEventListener('keydown', event => {
      if (!active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeMenu();
      } else if (event.key === 'Tab') {
        const focusable = Array.from(portal.querySelectorAll('a[href],button,summary,input,select,textarea,[tabindex]'))
          .filter(node => !node.disabled && node.tabIndex >= 0 && !node.closest('[hidden],[inert]') && node.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (first && event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (last && !event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }
    });
    new MutationObserver(() => {
      if ((wrapper.hasAttribute('open') && media.matches) !== active) syncMenu();
    }).observe(wrapper, {attributes:true, attributeFilter:['open']});
    window.addEventListener('resize', syncMenu, {passive:true});
    window.addEventListener('pageshow', syncMenu);
    window.visualViewport?.addEventListener('resize', geometry, {passive:true});
    window.visualViewport?.addEventListener('scroll', geometry, {passive:true});
    syncMenu();
  }

  function blockedOffers() {
    if (/(?:^|\/)cart(?:\/|$)/.test(location.pathname)) return true;
    const drawer = document.getElementById('Cart-Drawer');
    if (drawer && !observedDrawers.has(drawer)) {
      observedDrawers.add(drawer);
      new MutationObserver(queueOffers).observe(drawer, {attributes:true,attributeFilter:['inert','class','aria-hidden']});
    }
    return !!((drawer && !drawer.hasAttribute('inert') && drawer.getAttribute('aria-hidden') !== 'true') ||
      document.querySelector('.dl-mobile-toggle-wrapper[open]') || root.classList.contains('daluca-universal-viewer-open'));
  }

  function offerHidden(node, hidden) {
    let record = offerRecords.get(node);
    if (!record) {
      record = { hidden: false, visibility: node.style.getPropertyValue('visibility'),
        visibilityPriority: node.style.getPropertyPriority('visibility'),
        opacity: node.style.getPropertyValue('opacity'), opacityPriority: node.style.getPropertyPriority('opacity'),
        pointer: node.style.getPropertyValue('pointer-events'), pointerPriority: node.style.getPropertyPriority('pointer-events'),
        aria: node.getAttribute('aria-hidden'), inert: node.hasAttribute('inert') };
      offerRecords.set(node, record);
      new MutationObserver(queueOffers).observe(node, {attributes:true,attributeFilter:['style','class','hidden']});
    }
    if (record.hidden === hidden) return;
    record.hidden = hidden;
    if (hidden) {
      node.setAttribute('data-dl-launch-offer-hidden', ''); node.setAttribute('aria-hidden', 'true'); node.setAttribute('inert', '');
      node.style.setProperty('visibility', 'hidden', 'important'); node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    } else {
      node.removeAttribute('data-dl-launch-offer-hidden');
      [['visibility', record.visibility, record.visibilityPriority], ['opacity', record.opacity, record.opacityPriority],
        ['pointer-events', record.pointer, record.pointerPriority]].forEach(([key,value,priority]) => {
        if (value) node.style.setProperty(key,value,priority); else node.style.removeProperty(key);
      });
      if (record.aria === null) node.removeAttribute('aria-hidden'); else node.setAttribute('aria-hidden',record.aria);
      if (!record.inert) node.removeAttribute('inert');
    }
  }

  function hasRenderedFields(node) {
    // Inspect geometry, never input values. A hidden signup step is not a teaser.
    return Array.from(node.querySelectorAll('input:not([type="hidden"]),select,textarea')).some(field => {
      const box = field.getBoundingClientRect(); return box.width > 0 && box.height > 0;
    });
  }

  function teaserContainer(label) {
    let candidate = null, node = label, fixed = false;
    const vh = window.innerHeight, vw = document.documentElement.clientWidth;
    // Accept only the exact compact offer launcher, never an input form or dialog.
    for (let level = 0; node && level < 9; level += 1) {
      if (!(node instanceof Element) || node === document.body || node === root) break;
      const rect = node.getBoundingClientRect(), style = getComputedStyle(node);
      if (hasRenderedFields(node)) break;
      if (rect.width > 30 && rect.width <= vw + 2 && rect.height >= 20 && rect.height <= 150 && rect.bottom >= vh * .65) {
        if (style.backgroundColor !== 'rgba(0, 0, 0, 0)' || node.matches('button,[role="button"]')) candidate = node;
      }
      // A provider may mount a compact teaser inside a transparent full-height
      // fixed portal. Use that portal only as a positioning anchor, never hide it.
      if (style.position === 'fixed') { fixed = true; break; }
      node = node.parentElement || node.getRootNode().host;
    }
    return fixed ? candidate : null;
  }

function compactShopifyOffer(host) {
  const scope = host && host.shadowRoot;
  if (!scope || host.id !== 'app-embed-container-82063' || scope.querySelector('[data-dl-launch-compact-offer-style]')) return;
  const style = document.createElement('style');
  style.setAttribute('data-dl-launch-compact-offer-style', '');
  window.DaLucaI18n.setText(style, `
    #app-embed[data-current-step="tease"] {
      box-sizing: border-box !important;
      width: max-content !important;
      min-width: 0 !important;
      max-width: calc(100vw - 24px) !important;
      height: auto !important;
      min-height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      inset-inline: auto !important;
      left: 50% !important;
      right: auto !important;
      bottom: calc(12px + env(safe-area-inset-bottom, 0px)) !important;
      transform: translateX(-50%) !important;
      background: transparent !important;
      border: 0 !important;
      border-radius: 24px !important;
    }
    #app-embed[data-current-step="tease"] [data-testid="form-teaser"] {
      box-sizing: border-box !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      gap: 2px !important;
      width: max-content !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: 44px !important;
      min-height: 44px !important;
      padding: 0 0 0 16px !important;
      margin: 0 !important;
      border: 0 !important;
      border-radius: 24px !important;
      background: #f5f4f0 !important;
      color: #000 !important;
      box-shadow: 0 3px 18px rgb(0 0 0 / 16%) !important;
    }
    #app-embed[data-current-step="tease"] [data-testid="form-teaser"] h3 {
      flex: 0 0 auto !important;
      width: auto !important;
      margin: 0 !important;
      padding: 0 !important;
      font: 700 13px/1.2 Arial, Helvetica, sans-serif !important;
      letter-spacing: 0 !important;
      color: #000 !important;
      white-space: nowrap !important;
    }
    #app-embed[data-current-step="tease"] [data-testid="form-teaser"] [role="button"] {
      box-sizing: border-box !important;
      display: inline-flex !important;
      position: static !important;
      align-items: center !important;
      justify-content: center !important;
      flex: 0 0 44px !important;
      width: 44px !important;
      height: 44px !important;
      min-width: 44px !important;
      min-height: 44px !important;
      margin: 0 !important;
      padding: 0 !important;
      border: 0 !important;
      border-radius: 50% !important;
      background: transparent !important;
      color: #666 !important;
      transform: none !important;
    }
    #app-embed[data-current-step="tease"] [data-testid="form-teaser"] [role="button"] svg {
      width: 12px !important;
      height: 12px !important;
      color: inherit !important;
    }
  `);
  scope.appendChild(style);
}

  function offers() {
    teaserTimer = 0;
    const scopes = [document];
    document.querySelectorAll('shopify-forms-embed, shopify-forms, .klaviyo-form').forEach(host => {
      compactShopifyOffer(host);
      if (host.shadowRoot) {
        scopes.push(host.shadowRoot);
        if (!shadowRoots.has(host.shadowRoot)) {
          shadowRoots.add(host.shadowRoot);
          new MutationObserver(queueOffers).observe(host.shadowRoot, {childList:true,subtree:true});
        }
      }
    });
    const blocked = blockedOffers();
    const shopifyOffer = document.querySelector('shopify-forms-embed#app-embed-container-82063');
    if (shopifyOffer) offerHidden(shopifyOffer, blocked);
    document.querySelectorAll('[class*="kl-teaser-"]').forEach(teaser => {
      if (/GET\s*10\s*%\s*OFF/i.test(window.DaLucaI18n.sourceText(teaser) || '')) {
        teaser.setAttribute('data-dl-launch-compact-klaviyo', '');
        offerHidden(teaser, blocked || !!shopifyOffer);
      }
    });
    const found = new Set();
    scopes.forEach(scope => scope.querySelectorAll('button,[role="button"],a,p,span').forEach(label => {
      if (!/^GET\s*10\s*%\s*OFF(?:\s*[×✕✖xX])?\s*$/i.test((window.DaLucaI18n.sourceText(label) || '').trim())) return;
      const box = teaserContainer(label);
      if (box) found.add(box);
    }));
    offerRecords.forEach((record,node) => {
      if (node.matches('shopify-forms-embed#app-embed-container-82063, [class*="kl-teaser-"]')) return;
      const box = node.getBoundingClientRect();
      if (!node.isConnected || box.height > 150 || hasRenderedFields(node)) {
        if (node.isConnected) offerHidden(node, false);
        offerRecords.delete(node);
        found.delete(node);
        if (preferredOffer === node) preferredOffer = null;
      } else found.add(node);
    });
    const candidates = Array.from(found).filter(node => {
      const rect = node.getBoundingClientRect(); return rect.width > 0 && rect.height > 0;
    });
    // Preserve the actual rounded tab, unchanged. Suppress competing launchers only
    // when that approved-looking compact rounded tab is present. Do not disable apps.
    if (!preferredOffer || !preferredOffer.isConnected) {
      const rounded = candidates.filter(node => parseFloat(getComputedStyle(node).borderTopLeftRadius) >= 4 && node.getBoundingClientRect().width <= 240);
      preferredOffer = rounded.sort((a,b) => a.getBoundingClientRect().width - b.getBoundingClientRect().width)[0] || null;
      if (preferredOffer) preferredSeen = true;
    }
    candidates.forEach(node => {
      const belongsToShopify = shopifyOffer && node.getRootNode().host === shopifyOffer;
      const competing = shopifyOffer ? !belongsToShopify : preferredSeen && node !== preferredOffer;
      offerHidden(node, blocked || competing);
    });
  }
  function queueOffers() { if (!teaserTimer) teaserTimer = setTimeout(offers, 100); }
  function sync() { frame = 0; stationaryGalleryZoom(); captionClearance(); editingPlacement(); cartControls(); queueOffers(); }
  function queue() { if (!frame) frame = requestAnimationFrame(sync); }

  const observer = new MutationObserver(queue);
  observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['aria-pressed']});
  new MutationObserver(queue).observe(root, {attributes:true,attributeFilter:['data-daluca-cart-editing','class']});
  document.addEventListener('panel:open', queueOffers);
  document.addEventListener('panel:closed', queueOffers);
  document.addEventListener('cart-drawer:open', queueOffers);
  document.addEventListener('cart:refresh', queue);
  document.addEventListener('line-item:change:end', queue);
  document.addEventListener('click', queueOffers, {passive:true});
  window.addEventListener('resize', queue, {passive:true});
  window.addEventListener('pageshow', queue);
  mobileMenu();
  queue();
})();



